module.exports = __webpack_public_path__ + "static/media/play.4a629f3a.svg";